import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { PageContentState, WebsitePage } from 'global';
import { availableLanguages, baseApi } from '../components/api';

// Async thunk to fetch page content
export const fetchPageContent = createAsyncThunk(
    'pageContent/fetchPageContent',
    async (pagePath: string): Promise<{ path: keyof WebsitePage; data: WebsitePage[keyof WebsitePage] }> => {
        const pathParts = pagePath.split('/') // Extract language prefix if it exists (e.g., "/ar" -> "ar")
        const possibleLang = pathParts[1] // First part after the initial slash
        const isLanguagePrefix = availableLanguages.includes(possibleLang) // Check if the first part is a language code (e.g., "en", "ar")
        let pathWithoutLang = isLanguagePrefix ? pagePath.replace(`/${possibleLang}`, '') : pagePath
        pathWithoutLang = pathWithoutLang.startsWith('/') ? pathWithoutLang.slice(1) : pathWithoutLang
        let path = pathWithoutLang === '/' ? 'home/' : pathWithoutLang // Handle special case for home page
        if (path.endsWith('/')) { path = path.slice(0, -1) } // Remove trailing slash if it exists
        path = path.startsWith('/') ? path.slice(1) : path
        // console.log("Path: ", path)
        const response = await axios.get(baseApi + `/api/website/${path}`)
        return { path: pagePath as keyof WebsitePage, data: response.data.data }
    }
);
export const createOrUpdateData = createAsyncThunk(
    'website/createOrUpdateData',
    async (data: any) => {
        await axios.post(baseApi + '/api/website', data);
        return data;
    }
);
export const deleteData = createAsyncThunk('website/deleteData', async (id: number) => {
    await axios.delete(baseApi + `/api/website/${id}`);
    return id;
});
const pageContentSlice = createSlice({
    name: 'pageContent',
    initialState:{
        apiData: {}, // Cache for page content
        content: {}, // Cache for page content
        loading: false,
        error: null,
    } as PageContentState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchPageContent.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchPageContent.fulfilled, (state, action: PayloadAction<{ path: keyof WebsitePage; data: WebsitePage[keyof WebsitePage] }>) => {
            state.loading = false;
            state.apiData[action.payload.path] = action.payload.data;
            state.content[action.payload.path] = action.payload.data;
        })
        .addCase(fetchPageContent.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || 'Failed to fetch page content';
        })
        .addCase(createOrUpdateData.fulfilled, (state, action) => {
            state.apiData = action.payload;
        })
        .addCase(deleteData.fulfilled, (state, action) => {
            // state.apiData = state.apiData.filter((item: any) => item.id !== action.payload);
        });
    },
});

export default pageContentSlice.reducer;
